import useTreatments from 'hooks/useTreatments';
import { treatments } from '../treatments';

export const useBuyerNewOfferPayloadStruct = () => {
	return useTreatments(treatments.backend_driven_offer_payload_react);
};
